<div class="relationship-dialog">
    <h2 class="dialog-title">Relationship Request</h2>
    <p class="dialog-message">
      Are you sure you want to send a relationship request to 
      <strong>"{{ capitalizeFirstLetter(data.firstName)}}  {{capitalizeFirstLetter(data.lastName) }}"</strong> ?
    </p>
  
    <form [formGroup]="myForm">
      <div class="input-wrapper">
        <input placeholder="Description (Optional)" #descriptionInput 
               type="text" formControlName="desc" />
      </div>
    </form>
  
    <div class="dialog-actions">
      <button class="btn cancel" (click)="cancel()">Cancel</button>
      <button class="btn send" (click)="confirm(descriptionInput.value)">Send</button>
    </div>
  </div>
  